// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"86c2702c","513":"43fef056","703":"cb0eb30a"}[chunkId] + ".chunk.js";
};